export const haveObjectsDifferentValues = (obj1?: object, obj2?: object) => {
  if ((obj1 && !obj2) || (!obj1 && obj2)) return true;
  if (!obj1 || !obj2) return false;

  return Object.entries(obj1).some(
    ([key, value]) => (obj2 as Record<string, unknown>)[key] !== value
  );
};
